module.exports = __webpack_public_path__ + "img/IT0001039487584.f43dfa5d.png";